import { Component, OnInit } from '@angular/core';
import {SearchRequestService} from '../../../../shared/service/search-request.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgWizardService} from 'ng-wizard';
import {ActivatedRoute, Params} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ApprovalService} from '../../../../service/approval.service';
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {FormControl, FormGroup} from '@angular/forms';
import {ApplicantRequestSearchModel} from '../../../../model/applicantRequestSearchModel';

@Component({
  selector: 'app-biometric-info',
  templateUrl: './biometric-info.component.html',
  styleUrls: ['./biometric-info.component.scss']
})
export class BiometricInfoComponent implements OnInit {

  public requestId: string;
  public retrievedImage: string;
  public base64Data: string;
  public signature: string;
  public imgrighthand: string;
  public imglefthand: string;
  public thumbright: string;
  public thumbleft: string;
  public id: number;

  applicantSearchForm: FormGroup;
  applicantRequestSearchDetails: ApplicantRequestSearchModel;

  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              private spinnerService: NgxUiLoaderService,
              private requestSearchService: SearchRequestService,
              private approvalService: ApprovalService,
              private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.applicantSearchForm = new FormGroup({
      remark: new FormControl(null),
      appRefNo: new FormControl(null),
      appType: new FormControl(null),
      status: new FormControl(null),
      createDate: new FormControl(null),
      cdcNo: new FormControl(null),
      cocNo: new FormControl(null),
      cdcExpDate: new FormControl(null),
      cocDate: new FormControl(null),
      fullName: new FormControl(null),
      familyName: new FormControl(null),
      givenName: new FormControl(null),
      initialName: new FormControl(null),
      nic: new FormControl(null),
      nicIssueDate: new FormControl(null),
      dob: new FormControl(null),
      gender: new FormControl(null),
      birthPlace: new FormControl(null),
      nationality: new FormControl(null),
      specialCharac: new FormControl(null),
      bioRefNo: new FormControl(null),
      photoDate: new FormControl(null),
      photoExpDate: new FormControl(null),
      address: new FormControl(null),
      mobile: new FormControl(null),
      email: new FormControl(null),
    });
    this.onGetIdFromUrl();
    this.loadBiometricData();
    this.getApplicantDetails();
  }

  loadBiometricData() {

  }

  onGetIdFromUrl() {
    this.route.params.subscribe(
      (param: Params) => {
        this.requestId = param.requestId;
        this.id = param.requestId;
      }
    );
  }

  getApplicantDetails(){
    this.approvalService.getApplicantDetails(this.id).subscribe(
      (data: ApplicantRequestSearchModel) =>{
        this.applicantRequestSearchDetails = data;
        this.applicantSearchForm.patchValue(
          {
            bioRefNo: this.applicantRequestSearchDetails.reference,
            photoDate: this.applicantRequestSearchDetails.photodate,
            photoExpDate: this.applicantRequestSearchDetails.expiryDate,
          }
        );
        this.retrievedImage = this.applicantRequestSearchDetails.image;
        this.signature = this.applicantRequestSearchDetails.imgsignature;
        this.imgrighthand = this.applicantRequestSearchDetails.imgrighthand;
        this.imglefthand = this.applicantRequestSearchDetails.imglefthand;
        this.thumbright = this.applicantRequestSearchDetails.thumbright;
        this.thumbleft = this.applicantRequestSearchDetails.thumbleft;

        this.base64Data = window.atob(this.retrievedImage);
      }
    )
  }

}
